import BotService from "../../services/bot.service";
import _ from "lodash";
import Vue from 'vue';
import UserService from "../../services/user.service";
import router from "@/router";
import {make} from "vuex-pathify";
import AppService from "@/services/app.service";
import i18n from "@/plugins/i18n";

const state = () => ({
    botConfig: {},
    agentConfig: {},
    userConfig: {}
});
const mutations = {
    ...make.mutations(state),
    setBotConfig(state, config) {
        for (let key of Object.keys(config)) {
            let _key = _.camelCase(key);
            Vue.set(state.botConfig, _key, config[key])
        }
    },
    setAgentConfig(state, config) {
        for (let key of Object.keys(config)) {
            let _key = _.camelCase(key);
            Vue.set(state.agentConfig, _key, config[key])
        }
    },
    setUserConfig(state, config) {
        for (let key of Object.keys(config)) {
            let _key = _.camelCase(key);
            Vue.set(state.userConfig, _key, config[key])
        }
    }
};
const actions = {
    getBotConfig(context, botCode) {
        BotService.getBotConfig(botCode).then(res=> {
            context.commit('setBotConfig', res.data)
        })
    },
    getAgentConfig(context, botCode) {
        BotService.getAgentConfigs(botCode).then(res => {
            context.commit('setAgentConfig', res.data)
        })
    },
    getUserConfig(context) {
        UserService.getUserConfig().then(res => {
            context.commit('setUserConfig', res.data)
        })
    },
    enableNotify({commit}) {
        const botCode = router.currentRoute.params.bot_code;
        UserService.enableNotify(botCode)
            .then((res) => {
                commit('SET_USER_CONFIG', res.data)
                AppService.toastSuccess(i18n.t('success'))
            })
            .catch(() => {
                AppService.toastError(i18n.t('failed'))
            })
    },
    disableNotify({commit}) {
        const botCode = router.currentRoute.params.bot_code;
        UserService.disableNotify(botCode)
            .then((res) => {
                commit('SET_USER_CONFIG', res.data)
                AppService.toastSuccess(i18n.t('success'))
            })
            .catch(() => {
                AppService.toastError(i18n.t('failed'))
            })
    }
};
const getters = {
    isEnableNotify(state) {
        const botCode = router.currentRoute.params.bot_code;
        return !state.userConfig.notifications || !state.userConfig.notifications.includes(botCode)
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
